import clsx from 'clsx';
export function applyCentreTheme(input = 'core') {
    return clsx(input === 'core' && 'centre-theme-core', input === 'luxury' && 'centre-theme-luxury', input === 'mainstream' && 'centre-theme-mainstream', input === 'premium' && 'centre-theme-premium');
}
export function applyTheme(input = 'light-a') {
    return clsx(input === 'light-a' && 'theme-light-a', input === 'dark-a' && 'theme-dark-a', input === 'dark-b' && 'theme-dark-b', input === 'light-b' && 'theme-light-b');
}
export function applyTopPadding(topPadding) {
    return clsx(topPadding === 'sm' && 'spacing-t-sm', topPadding === 'md' && 'spacing-t-md', topPadding === 'lg' && 'spacing-t-lg');
}
export function applyBottomPadding(bottomPadding) {
    return clsx(bottomPadding === 'sm' && 'spacing-b-sm', bottomPadding === 'md' && 'spacing-b-md', bottomPadding === 'lg' && 'spacing-b-lg');
}
